import { MarketButton, MarketEmptyState } from '@market/react';
import { useTranslation } from 'react-i18next';
import { DASHBOARD_URL } from '../utils';

import styles from './redeem_success.module.scss';

export const REDEEM_SUCCESS_TEST_ID = 'redeem-success';

const RedeemSuccess = () => {
  const { t } = useTranslation();

  return (
    <MarketEmptyState
      data-testid={REDEEM_SUCCESS_TEST_ID}
      className={styles.redeemSuccess}
    >
      <h2 className={styles.successTitle}>{t('redeem.success.title')}</h2>
      <p className={styles.successMessage}>{t('redeem.success.message')}</p>
      <MarketButton
        className={styles.successCta}
        rank="primary"
        href={DASHBOARD_URL}
      >
        {t('redeem.success.cta')}
      </MarketButton>
    </MarketEmptyState>
  );
};

export default RedeemSuccess;
